import { render, staticRenderFns } from "./DinamicListFilter.html?vue&type=template&id=22387202&scoped=true&external"
import script from "./DinamicListFilter.vue?vue&type=script&lang=js"
export * from "./DinamicListFilter.vue?vue&type=script&lang=js"
import style0 from "./DinamicListFilter.scss?vue&type=style&index=0&id=22387202&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22387202",
  null
  
)

export default component.exports